var swiper = new Swiper(".product-thumbnails-slider", {
      spaceBetween: 10,
      slidesPerView: 5,
      freeMode: true,
       centeredSlides: false,
  centeredSlidesBounds: false,
      watchSlidesProgress: true,
       breakpoints: {

    480: {
      slidesPerView: 5,
      spaceBetween: 10
    },

    768: {
      slidesPerView: 5,
      spaceBetween: 10
    },

    992: {
      slidesPerView: 5,
      spaceBetween: 10
    }
  },
    });
    var swiper2 = new Swiper(".product-slider", {
      spaceBetween: 2,
      thumbs: {
        swiper:  swiper,
      },
    });
    
      var swiper3 = new Swiper('.peace-slider', {
  centeredSlides: false,
  loop: false,
  slidesPerView: 1,
      spaceBetween: 10,
       pagination: {
    el: '.peace-pagination',
    clickable: true,
  },
       breakpoints: {

    480: {
      slidesPerView: 1,
      spaceBetween: 10
    },

    992: {
      slidesPerView: 2,
      spaceBetween: 28
    },

    1024: {
      slidesPerView: 3,
      spaceBetween: 28
    }
  },
  });
  
        var swiper4 = new Swiper('.magic-slider', {
  centeredSlides: false,
  loop: false,
  slidesPerView: 1,
      spaceBetween: 10,
       pagination: {
    el: '.magic-pagination',
    clickable: true,
  },
       breakpoints: {

    480: {
      slidesPerView: 1,
      spaceBetween: 10
    },

    992: {
      slidesPerView: 2,
      spaceBetween: 20
    },

    1024: {
      slidesPerView: 3,
      spaceBetween: 128
    }
  },
  });
 
  var swiper5 = new Swiper('.featured-products-slider', {
  centeredSlides: false,
  loop: false,
  slidesPerView: 1,
      spaceBetween: 10,
       pagination: {
    el: '.featured-products-pagination',
    clickable: true,
  },
       breakpoints: {

    480: {
      slidesPerView: 1,
      spaceBetween: 10
    },

    992: {
      slidesPerView: 2,
      spaceBetween: 28
    },

    1024: {
      slidesPerView: 2,
      spaceBetween: 30
    }
  },
    });
    
         var swiper6 = new Swiper('.gallery-slider', {
  centeredSlides: false,
  loop: false,
  slidesPerView: 1,
      spaceBetween: 10,
       pagination: {
    el: '.gallery-pagination',
    clickable: true,
  },
       breakpoints: {

    480: {
      slidesPerView: 1,
      spaceBetween: 10
    },

    992: {
      slidesPerView: 2,
      spaceBetween: 28
    },

    1024: {
      slidesPerView: 3,
      spaceBetween: 28
    }
  },
  });

$(document).ready(function() {
    $('.hp-color-item').click(function() {
        $('.hp-color-item').removeClass('color-active');
        $(this).addClass('color-active');
    });
});

$(document).ready(function() {
    $('.detail-item').click(function() {
        $('.detail-item').removeClass('detail-active');
        $(this).addClass('detail-active');
    });
  setTimeout(function(){
$('.swatch--color').click(function () {
      // Get the swatch color
      var swatchColor = $(this).attr('data-swatch-option');
      console.log(swatchColor);
      // Find the slide with the corresponding variant
      var slideIndex = $('.swiper-slide[data-variants*="' + swatchColor + '"]').index();

      // Slide to the selected variant
      swiper2.slideTo(slideIndex);
   swiper.slideTo(slideIndex);
    });

  $('.swiper-slide').click(function(){
    $('.swiper-slide').removeClass('swiper-slide-active swiper-slide-thumb-active');
    $(this).addClass('swiper-slide-active swiper-slide-thumb-active');
  });
  },1000);

});
